import { createAction, props } from '@ngrx/store';

import { Attachment, JobBoard, JobBoardPost } from '@shared/models';
import { Pagination } from '@shared/pagination';

export const loadJobBoards = createAction(
  '[JobBoard] Load Job Boards',
  props<{ offset: number }>(),
);

export const getJobBoard = createAction(
  '[JobBoard] Get Job Board',
  props<{ jobBoardId: number }>(),
);

export const getJobBoardSuccess = createAction(
  '[JobBoard] Get Job Board Success',
  props<{ jobBoard: JobBoard }>(),
);

export const getJobBoardFailure = createAction(
  '[JobBoard] Get Job Board Success',
  props<{ error: any }>(),
);

export const loadJobBoardsSuccess = createAction(
  '[JobBoard] Load Job Boards Success',
  props<{ jobBoards: Pagination<JobBoard> }>(),
);

export const loadJobBoardsFailure = createAction(
  '[JobBoard] Load Job Boards Failure',
  props<{ error: any }>(),
);

export const updateJobBoard = createAction(
  '[JobBoard] Update Job Board',
  props<{ jobBoard: Partial<JobBoard> }>(),
);

export const updateJobBoardSuccess = createAction(
  '[JobBoard] Update Job Board Success',
  props<{ jobBoard: JobBoard }>(),
);

export const updateJobBoardFailure = createAction(
  '[JobBoard] Update Job Board Failure',
  props<{ error: any }>(),
);

export const getActiveJobBoardsForJob = createAction(
  '[JobBoard] Load Active Job Boards For Job',
  props<{ jobId: number }>(),
);

export const getActiveJobBoardsForJobSuccess = createAction(
  '[JobBoard] Load Active Job Boards For Job Success',
  props<{ jobBoardsForJob: any }>(),
);

export const getActiveJobBoardsForJobFailure = createAction(
  '[JobBoard] Load Active Job Boards For Job Failure',
  props<{ error: any }>(),
);

export const loadJobBoardsWithoutPagination = createAction(
  '[JobBoard] Load Active Job Boards Without Pagination',
);

export const loadJobBoardsWithoutPaginationSuccess = createAction(
  '[JobBoard] Load Active Job Boards Without Pagination Success',
  props<{ allJobBoards: JobBoard[] }>(),
);

export const loadJobBoardsWithoutPaginationFailure = createAction(
  '[JobBoard] Load Active Job Boards Without Pagination Failure',
  props<{ error: any }>(),
);

export const updateJobBoardPostForJob = createAction(
  '[JobBoard] Update Job Board Post For Job',
  props<{ partialJobBoardPost: Partial<JobBoardPost> }>(),
);

export const updateJobBoardPostForJobSuccess = createAction(
  '[JobBoard] Update Job Board Post For Job Success',
  props<{ jobBoardPost: JobBoardPost }>(),
);

export const updateJobBoardPostForJobFailure = createAction(
  '[JobBoard] Update Job Board Post For Job Failure',
  props<{ error: any }>(),
);

export const getImageJobBoard = createAction(
  '[JobBoard] Get Image Job Board',
  props<{ id: number }>(),
);

export const getImageJobBoardSuccess = createAction(
  '[JobBoard] Get Image Job Board Success',
  props<{ attachment: Attachment }>(),
);

export const getImageJobBoardFailure = createAction(
  '[JobBoard] Get Image Job Board Failure',
  props<{ error: any }>(),
);

export const selectJobBoard = createAction(
  '[JobBoard] Select Job Board',
  props<{ jobBoard: JobBoard }>(),
);

export const unselectJobBoard = createAction('[JobBoard] Unselect Job Board');

export const uploadLogoJobBoard = createAction(
  '[JobBoard] Upload Logo Job Board',
  props<{ attachment: Partial<Attachment>; file: File }>(),
);

export const uploadLogoJobBoardSuccess = createAction(
  '[JobBoard] Upload Logo Job Board Success',
  props<{ attachment: Attachment }>(),
);

export const uploadLogoJobBoardFailure = createAction(
  '[JobBoard] Upload Logo Job Board Failure',
  props<{ error: any }>(),
);

export const uploadHeaderJobBoard = createAction(
  '[JobBoard] Upload Header Job Board',
  props<{ attachment: Partial<Attachment>; file: File }>(),
);

export const uploadHeaderJobBoardSuccess = createAction(
  '[JobBoard] Upload Header Job Board Success',
  props<{ attachment: Attachment }>(),
);

export const uploadHeaderJobBoardFailure = createAction(
  '[JobBoard] Upload Header Job Board Failure',
  props<{ error: any }>(),
);

export const createJobBoard = createAction(
  '[JobBoard] Create Job Board',
  props<{ jobBoard: Partial<JobBoard> }>(),
);

export const createJobBoardSuccess = createAction(
  '[JobBoard] Create Job Board Success',
  props<{ jobBoard: JobBoard }>(),
);

export const createJobBoardFailure = createAction(
  '[JobBoard] Create Job Board Failure',
  props<{ error: any }>(),
);

export const loadNumberOfJobsForExtendedReferral = createAction(
  '[JobBoard] Load Number of Jobs For Extended Referral',
  props<{ jobBoardCanonicalName: string }>(),
);

export const loadNumberOfJobsForExtendedReferralSuccess = createAction(
  '[JobBoard] Load Number of Jobs For Extended Referral Success',
  props<{ totalElements: number }>(),
);
